/** 邮件资料包弹窗文案 */
export const emailLeadTranslations = {
  zh: {
    emailLeadTitle: "获取免费打印创业资料包",
    emailLeadDesc: "留下邮箱领取：",
    emailLeadItem1: "产品目录",
    emailLeadItem2: "视频案例",
    emailLeadItem3: "成本利润分析",
    emailLeadItem4: "设备选型指南",
    emailLeadPlaceholder: "请输入您的邮箱",
    emailLeadSubmit: "立即获取",
    emailLeadSubmitting: "提交中…",
    emailLeadSubmitError: "提交失败，请稍后重试。",
    emailLeadClose: "关闭",
    emailLeadSuccessTitle: "提交成功！",
    emailLeadSuccessDesc: "资料包将发送至您的邮箱，请注意查收。",
  },
  en: {
    emailLeadTitle: "Get Your Free Printing Business Starter Kit",
    emailLeadDesc: "Leave your email to receive:",
    emailLeadItem1: "Product catalog",
    emailLeadItem2: "Video case studies",
    emailLeadItem3: "Cost & profit analysis",
    emailLeadItem4: "Equipment selection guide",
    emailLeadPlaceholder: "Enter your email address",
    emailLeadSubmit: "Get It Now",
    emailLeadSubmitting: "Submitting…",
    emailLeadSubmitError: "Submission failed. Please try again.",
    emailLeadClose: "Close",
    emailLeadSuccessTitle: "Success!",
    emailLeadSuccessDesc: "Your starter kit will be sent to your inbox shortly.",
  },
  de: {
    emailLeadTitle: "Kostenloses Druck-Startup-Paket erhalten",
    emailLeadDesc: "E-Mail hinterlassen und erhalten:",
    emailLeadItem1: "Produktkatalog",
    emailLeadItem2: "Video-Referenzen",
    emailLeadItem3: "Kosten- & Gewinnanalyse",
    emailLeadItem4: "Geräteauswahl-Leitfaden",
    emailLeadPlaceholder: "E-Mail-Adresse eingeben",
    emailLeadSubmit: "Jetzt erhalten",
    emailLeadSubmitting: "Wird gesendet…",
    emailLeadSubmitError: "Senden fehlgeschlagen. Bitte später erneut versuchen oder kontaktieren Sie uns.",
    emailLeadClose: "Schließen",
    emailLeadSuccessTitle: "Erfolgreich gesendet!",
    emailLeadSuccessDesc: "Das Paket wird in Kürze an Ihre E-Mail gesendet.",
  },
  pt: {
    emailLeadTitle: "Obtenha o kit gratuito de impressão",
    emailLeadDesc: "Deixe seu e-mail para receber:",
    emailLeadItem1: "Catálogo de produtos",
    emailLeadItem2: "Casos em vídeo",
    emailLeadItem3: "Análise de custo e lucro",
    emailLeadItem4: "Guia de seleção de equipamentos",
    emailLeadPlaceholder: "Digite seu e-mail",
    emailLeadSubmit: "Obter agora",
    emailLeadSubmitting: "Enviando…",
    emailLeadSubmitError: "Falha no envio. Tente novamente mais tarde ou fale conosco.",
    emailLeadClose: "Fechar",
    emailLeadSuccessTitle: "Enviado com sucesso!",
    emailLeadSuccessDesc: "O kit será enviado para seu e-mail em breve.",
  },
  es: {
    emailLeadTitle: "Obtenga el kit gratuito de impresión",
    emailLeadDesc: "Deje su correo para recibir:",
    emailLeadItem1: "Catálogo de productos",
    emailLeadItem2: "Casos en video",
    emailLeadItem3: "Análisis de costos y beneficios",
    emailLeadItem4: "Guía de selección de equipos",
    emailLeadPlaceholder: "Ingrese su correo electrónico",
    emailLeadSubmit: "Obtener ahora",
    emailLeadSubmitting: "Enviando…",
    emailLeadSubmitError: "Error al enviar. Inténtelo de nuevo más tarde o contáctenos.",
    emailLeadClose: "Cerrar",
    emailLeadSuccessTitle: "¡Enviado con éxito!",
    emailLeadSuccessDesc: "El kit se enviará a su correo en breve.",
  },
  fr: {
    emailLeadTitle: "Obtenez le kit gratuit d'impression",
    emailLeadDesc: "Laissez votre e-mail pour recevoir :",
    emailLeadItem1: "Catalogue produits",
    emailLeadItem2: "Études de cas vidéo",
    emailLeadItem3: "Analyse coûts & profits",
    emailLeadItem4: "Guide de sélection d'équipement",
    emailLeadPlaceholder: "Saisissez votre e-mail",
    emailLeadSubmit: "Obtenir maintenant",
    emailLeadSubmitting: "Envoi…",
    emailLeadSubmitError: "Échec de l’envoi. Réessayez plus tard ou contactez-nous.",
    emailLeadClose: "Fermer",
    emailLeadSuccessTitle: "Envoyé avec succès !",
    emailLeadSuccessDesc: "Le kit sera envoyé à votre e-mail sous peu.",
  },
  it: {
    emailLeadTitle: "Ottieni il kit gratuito di stampa",
    emailLeadDesc: "Lascia la tua email per ricevere:",
    emailLeadItem1: "Catalogo prodotti",
    emailLeadItem2: "Casi video",
    emailLeadItem3: "Analisi costi e profitti",
    emailLeadItem4: "Guida alla scelta dell'attrezzatura",
    emailLeadPlaceholder: "Inserisci la tua email",
    emailLeadSubmit: "Ottieni ora",
    emailLeadSubmitting: "Invio…",
    emailLeadSubmitError: "Invio non riuscito. Riprova più tardi o contattaci.",
    emailLeadClose: "Chiudi",
    emailLeadSuccessTitle: "Inviato con successo!",
    emailLeadSuccessDesc: "Il kit verrà inviato alla tua email a breve.",
  },
  hi: {
    emailLeadTitle: "मुफ़्त प्रिंटिंग स्टार्टर किट प्राप्त करें",
    emailLeadDesc: "ईमेल छोड़ें और प्राप्त करें:",
    emailLeadItem1: "उत्पाद कैटलॉग",
    emailLeadItem2: "वीडियो केस",
    emailLeadItem3: "लागत और लाभ विश्लेषण",
    emailLeadItem4: "उपकरण चयन गाइड",
    emailLeadPlaceholder: "अपना ईमेल दर्ज करें",
    emailLeadSubmit: "अभी प्राप्त करें",
    emailLeadSubmitting: "भेजा जा रहा है…",
    emailLeadSubmitError: "सबमिट विफल। बाद में पुनः प्रयास करें या हमसे संपर्क करें।",
    emailLeadClose: "बंद करें",
    emailLeadSuccessTitle: "सफलतापूर्वक भेजा गया!",
    emailLeadSuccessDesc: "किट जल्द ही आपके ईमेल पर भेजी जाएगी।",
  },
  ru: {
    emailLeadTitle: "Получите бесплатный пакет для печатного бизнеса",
    emailLeadDesc: "Оставьте email и получите:",
    emailLeadItem1: "Каталог продукции",
    emailLeadItem2: "Видеокейсы",
    emailLeadItem3: "Анализ затрат и прибыли",
    emailLeadItem4: "Руководство по выбору оборудования",
    emailLeadPlaceholder: "Введите ваш email",
    emailLeadSubmit: "Получить сейчас",
    emailLeadSubmitting: "Отправка…",
    emailLeadSubmitError: "Не удалось отправить. Попробуйте позже или свяжитесь с нами.",
    emailLeadClose: "Закрыть",
    emailLeadSuccessTitle: "Успешно отправлено!",
    emailLeadSuccessDesc: "Пакет будет отправлен на ваш email в ближайшее время.",
  },
  ko: {
    emailLeadTitle: "무료 프린팅 창업 자료 패키지 받기",
    emailLeadDesc: "이메일을 남기시면 받으실 수 있습니다:",
    emailLeadItem1: "제품 카탈로그",
    emailLeadItem2: "영상 사례",
    emailLeadItem3: "비용·수익 분석",
    emailLeadItem4: "장비 선정 가이드",
    emailLeadPlaceholder: "이메일을 입력하세요",
    emailLeadSubmit: "지금 받기",
    emailLeadSubmitting: "제출 중…",
    emailLeadSubmitError: "제출에 실패했습니다. 나중에 다시 시도하거나 문의해 주세요.",
    emailLeadClose: "닫기",
    emailLeadSuccessTitle: "제출 완료!",
    emailLeadSuccessDesc: "자료 패키지가 곧 이메일로 발송됩니다.",
  },
  ja: {
    emailLeadTitle: "無料プリント起業資料パックを入手",
    emailLeadDesc: "メールアドレスを入力して受け取る：",
    emailLeadItem1: "製品カタログ",
    emailLeadItem2: "動画事例",
    emailLeadItem3: "コスト・利益分析",
    emailLeadItem4: "機器選定ガイド",
    emailLeadPlaceholder: "メールアドレスを入力",
    emailLeadSubmit: "今すぐ入手",
    emailLeadSubmitting: "送信中…",
    emailLeadSubmitError: "送信に失敗しました。しばらくしてから再試行するか、お問い合わせください。",
    emailLeadClose: "閉じる",
    emailLeadSuccessTitle: "送信完了！",
    emailLeadSuccessDesc: "資料パックはまもなくメールでお送りします。",
  },
  th: {
    emailLeadTitle: "รับชุดข้อมูลธุรกิจพิมพ์ฟรี",
    emailLeadDesc: "ฝากอีเมลเพื่อรับ:",
    emailLeadItem1: "แคตตาล็อกสินค้า",
    emailLeadItem2: "เคสวิดีโอ",
    emailLeadItem3: "วิเคราะห์ต้นทุนและกำไร",
    emailLeadItem4: "คู่มือเลือกอุปกรณ์",
    emailLeadPlaceholder: "กรอกอีเมลของคุณ",
    emailLeadSubmit: "รับทันที",
    emailLeadSubmitting: "กำลังส่ง…",
    emailLeadSubmitError: "ส่งไม่สำเร็จ โปรดลองใหม่ภายหลังหรือติดต่อเรา",
    emailLeadClose: "ปิด",
    emailLeadSuccessTitle: "ส่งสำเร็จ!",
    emailLeadSuccessDesc: "ชุดข้อมูลจะถูกส่งไปยังอีเมลของคุณเร็วๆ นี้",
  },
  tr: {
    emailLeadTitle: "Ücretsiz baskı girişim kitini alın",
    emailLeadDesc: "E-posta bırakın ve alın:",
    emailLeadItem1: "Ürün kataloğu",
    emailLeadItem2: "Video örnekleri",
    emailLeadItem3: "Maliyet ve kâr analizi",
    emailLeadItem4: "Ekipman seçim rehberi",
    emailLeadPlaceholder: "E-posta adresinizi girin",
    emailLeadSubmit: "Hemen al",
    emailLeadSubmitting: "Gönderiliyor…",
    emailLeadSubmitError: "Gönderim başarısız. Lütfen daha sonra tekrar deneyin veya bizimle iletişime geçin.",
    emailLeadClose: "Kapat",
    emailLeadSuccessTitle: "Başarıyla gönderildi!",
    emailLeadSuccessDesc: "Kit kısa süre içinde e-postanıza gönderilecek.",
  },
  vi: {
    emailLeadTitle: "Nhận bộ tài liệu khởi nghiệp in ấn miễn phí",
    emailLeadDesc: "Để lại email để nhận:",
    emailLeadItem1: "Danh mục sản phẩm",
    emailLeadItem2: "Case study video",
    emailLeadItem3: "Phân tích chi phí & lợi nhuận",
    emailLeadItem4: "Hướng dẫn chọn thiết bị",
    emailLeadPlaceholder: "Nhập email của bạn",
    emailLeadSubmit: "Nhận ngay",
    emailLeadSubmitting: "Đang gửi…",
    emailLeadSubmitError: "Gửi thất bại. Vui lòng thử lại sau hoặc liên hệ chúng tôi.",
    emailLeadClose: "Đóng",
    emailLeadSuccessTitle: "Gửi thành công!",
    emailLeadSuccessDesc: "Bộ tài liệu sẽ được gửi đến email của bạn sớm.",
  },
  nl: {
    emailLeadTitle: "Ontvang het gratis print starterpakket",
    emailLeadDesc: "Laat uw e-mail achter en ontvang:",
    emailLeadItem1: "Productcatalogus",
    emailLeadItem2: "Video cases",
    emailLeadItem3: "Kosten- & winstanalyse",
    emailLeadItem4: "Apparatuurkeuzegids",
    emailLeadPlaceholder: "Voer uw e-mail in",
    emailLeadSubmit: "Nu ontvangen",
    emailLeadSubmitting: "Bezig met verzenden…",
    emailLeadSubmitError: "Verzenden mislukt. Probeer het later opnieuw of neem contact op.",
    emailLeadClose: "Sluiten",
    emailLeadSuccessTitle: "Succesvol verzonden!",
    emailLeadSuccessDesc: "Het pakket wordt binnenkort naar uw e-mail gestuurd.",
  },
  id: {
    emailLeadTitle: "Dapatkan kit bisnis printing gratis",
    emailLeadDesc: "Tinggalkan email untuk menerima:",
    emailLeadItem1: "Katalog produk",
    emailLeadItem2: "Studi kasus video",
    emailLeadItem3: "Analisis biaya & profit",
    emailLeadItem4: "Panduan pemilihan peralatan",
    emailLeadPlaceholder: "Masukkan email Anda",
    emailLeadSubmit: "Dapatkan sekarang",
    emailLeadSubmitting: "Mengirim…",
    emailLeadSubmitError: "Pengiriman gagal. Coba lagi nanti atau hubungi kami.",
    emailLeadClose: "Tutup",
    emailLeadSuccessTitle: "Berhasil dikirim!",
    emailLeadSuccessDesc: "Kit akan segera dikirim ke email Anda.",
  },
  ar: {
    emailLeadTitle: "احصل على حزمة بدء الطباعة المجانية",
    emailLeadDesc: "اترك بريدك الإلكتروني للحصول على:",
    emailLeadItem1: "فهرس المنتجات",
    emailLeadItem2: "حالات فيديو",
    emailLeadItem3: "تحليل التكلفة والربح",
    emailLeadItem4: "دليل اختيار المعدات",
    emailLeadPlaceholder: "أدخل بريدك الإلكتروني",
    emailLeadSubmit: "احصل عليه الآن",
    emailLeadSubmitting: "جاري الإرسال…",
    emailLeadSubmitError: "فشل الإرسال. يُرجى المحاولة لاحقًا أو التواصل معنا.",
    emailLeadClose: "إغلاق",
    emailLeadSuccessTitle: "تم الإرسال بنجاح!",
    emailLeadSuccessDesc: "سيتم إرسال الحزمة إلى بريدك الإلكتروني قريباً.",
  },
  pl: {
    emailLeadTitle: "Odbierz darmowy pakiet startowy druku",
    emailLeadDesc: "Zostaw e-mail, aby otrzymać:",
    emailLeadItem1: "Katalog produktów",
    emailLeadItem2: "Case study wideo",
    emailLeadItem3: "Analiza kosztów i zysków",
    emailLeadItem4: "Przewodnik wyboru urządzeń",
    emailLeadPlaceholder: "Wpisz swój e-mail",
    emailLeadSubmit: "Odbierz teraz",
    emailLeadSubmitting: "Wysyłanie…",
    emailLeadSubmitError: "Wysyłanie nie powiodło się. Spróbuj ponownie później lub skontaktuj się z nami.",
    emailLeadClose: "Zamknij",
    emailLeadSuccessTitle: "Wysłano pomyślnie!",
    emailLeadSuccessDesc: "Pakiet zostanie wkrótce wysłany na Twój e-mail.",
  },
};
